import {WIDGET_PAGE} from "../PageProvider/PageTitles";
import {
    IconStudent,
    IconStaff,
    IconInbox,
    IconContent,
    IconHeart,
    IconSignUp,
    IconSettings,
    IconNotInterested,
    IconLogin,
    IconLogout,
    IconKey,
} from "../Icons";

export const MobileMenuPageMap = {
    [WIDGET_PAGE.WIDGET_STUDENTS]: {
        icon: IconStudent,
        text: "Students",
    },
    [WIDGET_PAGE.WIDGET_STAFF]: {
        icon: IconStaff,
        text: "Staff",
    },
    [WIDGET_PAGE.WIDGET_RECOMMENDATIONS]: {
        icon: IconHeart,
        text: "For You",
    },
    [WIDGET_PAGE.WIDGET_CONTENT]: {
        icon: IconContent,
        text: "Content",
    },
    [WIDGET_PAGE.WIDGET_INBOX]: {
        icon: IconInbox,
        text: "Inbox",
    },
    [WIDGET_PAGE.WIDGET_SIGNUP]: {
        icon: IconSignUp,
        text: "Sign up",
    },
    [WIDGET_PAGE.WIDGET_DECISION_STAGE]: {
        icon: IconStudent,
        text: "Decision Stage",
    },
    [WIDGET_PAGE.WIDGET_NOT_INTERESTED]: {
        icon: IconNotInterested,
        text: "Not Interested",
    },
    [WIDGET_PAGE.WIDGET_SETTINGS]: {
        icon: IconSettings,
        text: "Settings",
    },
    [WIDGET_PAGE.WIDGET_LOG_IN]: {
        icon: IconLogin,
        text: "Login",
    },
    [WIDGET_PAGE.WIDGET_LOG_OUT]: {
        icon: IconLogout,
        text: "Logout",
    },
    [WIDGET_PAGE.WIDGET_RESET_PASSWORD]: {
        icon: IconKey,
        text: "Reset Password",
    },
    [WIDGET_PAGE.UNKNOWN]: {
        icon: IconStudent,
        text: "Students",
    },
};
